<template>
  <main class="g-bg-transparent-fixed g-overflow-hidden">
    <!-- Main Banner -->
    <section id="score" class="js-carousel g-max-height-100vh">
      <transition name="fade">
        <div id="score" v-if="currentMatch">
          <!-- Promo Block -->
          <div class="g-height-50vh g-min-height-500--md">

            <div class="top-left g-ma-20 text-center g-color-white g-z-index-1">
                <table class="table g-font-weight-500 g-font-size-default g-font-size-10--md g-font-size-20">
                  <tbody>
                  <tr>
                    <th class="text-left g-bg-black-opacity-0_7">{{currentMatch.player1.lastname}}
                      <figure :class="getFlag(currentMatch,1)"></figure>
                    </th>
                    <td class="g-bg-black-opacity-0_7" v-if="currentMatch.startDate">{{currentMatch.sets[0].scorePlayer1}}</td>
                    <td class="g-bg-black-opacity-0_7" v-if="currentMatch.startDate">{{currentMatch.sets[1].scorePlayer1}}</td>
                    <td class="g-bg-black-opacity-0_7" v-if="currentMatch.startDate">{{currentMatch.sets[2].scorePlayer1}}</td>
                    <td class="g-bg-black-opacity-0_5" v-if="currentMatch.startDate">{{currentMatch.currentPointPlayer1}}</td>
                  </tr>
                  <tr>
                    <th class="text-left g-bg-black-opacity-0_7">{{currentMatch.player2.lastname}}
                      <figure :class="getFlag(currentMatch,2)"></figure>
                    </th>
                    <td class="g-bg-black-opacity-0_7" v-if="currentMatch.startDate">{{currentMatch.sets[0].scorePlayer2}}</td>
                    <td class="g-bg-black-opacity-0_7" v-if="currentMatch.startDate">{{currentMatch.sets[1].scorePlayer2}}</td>
                    <td class="g-bg-black-opacity-0_7" v-if="currentMatch.startDate">{{currentMatch.sets[2].scorePlayer2}}</td>
                    <td class="g-bg-black-opacity-0_5" v-if="currentMatch.startDate">{{currentMatch.currentPointPlayer2}}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          <!-- End Promo Block -->
        </div>
      </transition>
    </section>
  </main>
</template>

<script>
  export default {
    created () {
      this.$socket.emit('getCurrentMatch')
    },
    data () {
      return {
        currentMatch: undefined,
        currentPlayer: undefined,
        currentStat: undefined,
        currentTweet: undefined,
        display: 'score'
      }
    },
    sockets: {
      connection: function () {
        console.log('socket connection')
      },
      connect: function () {
        console.log('socket connected')
      },
      disconnect: function () {
        console.log('socket disconnected')
      },
      displayMatch (data) {
        if (data) {
          this.currentMatch = data
          this.display = 'score'
        }
      }
    },
    methods: {
      getTotalDuration: function (startDate, endDate, currentDate) {
        if (startDate) {
          const sDate = new Date(startDate)
          const eDate = endDate ? new Date(endDate) : currentDate ? new Date(currentDate) : new Date()
          let duration = Math.round((eDate.getTime() - sDate.getTime()) / 1000)
          if (duration < 0) {
            duration = 0
          }
          let hours = Math.floor(duration / 3600)
          let minutes = Math.floor((duration - (hours * 3600)) / 60)

          if (minutes < 10) {
            minutes = '0' + minutes
          }
          return hours + ':' + minutes
        } else {
          return '0\''
        }
      },
      getDuration: function (startDate, endDate, currentDate) {
        if (startDate) {
          const sDate = new Date(startDate)
          const eDate = endDate ? new Date(endDate) : currentDate ? new Date(currentDate) : new Date()
          let duration = Math.round((eDate.getTime() - sDate.getTime()) / 1000)
          if (duration < 0) {
            duration = 0
          }
          let hours = Math.floor(duration / 3600)
          let minutes = Math.floor((duration - (hours * 3600)) / 60) + hours * 60

          return minutes + '\''
        } else {
          return '0\''
        }
      },
      getFlag: function (match, playerIndex) {
        if (!match || !match.flags) {
          return ''
        }
        if (match.flags.winnerId === playerIndex) {
          return 'flagWinner'
        } else if (match.flags.serverId === playerIndex) {
          var scoreServer = match.currentPointPlayer1
          var scoreOther = match.currentPointPlayer2
          if (match.flags.serverId === 2) {
            scoreServer = match.currentPointPlayer2
            scoreOther = match.currentPointPlayer1
          }
          if (scoreOther === 'A') {
            return 'flagBreak'
          }
          if (scoreOther === '40') {
            if (scoreServer !== '40' && scoreServer !== 'A') {
              return 'flagBreak'
            }
          }
          return 'flagBall'
        }
        return ''
      },
      getCountryFlag: function (country) {
        if (!country) {
          return ''
        } else {
          return 'static/img/country/' + country.toLowerCase() + '.gif'
        }
      },
      getFace: function (face) {
        if (!face) {
          return 'static/img/player/face/avatar.jpg'
        }
        return 'static/img/player/face/' + face
      },
      getCard: function (face) {
        if (face) {
          return '/static/img/player/card/' + face.replace('png', 'jpg').toLowerCase()
        }
      },
      getLogo: function (logo) {
        if (logo) {
          return 'static/img/sponsor/' + logo
        }
      },
      getPercentage: function (value, total) {
        if (!value || !total) {
          return 0
        }
        if (value <= 0) {
          return 0
        }
        if (value >= total) {
          return 100
        }
        return (value * 100) / total
      },
      extractPercentage: function (value) {
        if (!value) {
          return 0
        }
        var i = value.indexOf('%')
        if (i <= 0) {
          return value
        }
        return value.substring(0, i)
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>



// WEBPACK FOOTER //
// src/components/Live.vue